module.exports = __webpack_public_path__ + "img/car_00051.b2fa0d13.jpg";